import React from 'react';
import type { Page } from '@/payload/payload-types';
import RichTextLexical from '../../_components/RichTextLexical';

type InfoboxBlock = Extract<Page['layoutBlocks'][0], { blockType: 'infoboxes' }>;

type DescriptionType =
	| InfoboxBlock['infoboxes'][0]['description']
	| string
	| string[]
	| React.ReactElement;

export type InfoboxBlockWithDescription = Omit<InfoboxBlock, 'infoboxes' | 'blockType'> & {
	infoboxes: (Omit<InfoboxBlock['infoboxes'][0], 'description'> & {
		description: DescriptionType;
	})[];
};

// Type guard to check if the description is a React element
function isReactElement(description: DescriptionType): description is React.ReactElement {
	return React.isValidElement(description);
}

export const InfoBoxes: React.FC<InfoboxBlockWithDescription> = ({ infoboxes, appearance }) => {
	if (!infoboxes) {
		return null;
	}
	return (
		<section className="infobox-grid">
			{infoboxes.map(({ title, category, description }, index) => (
				<div
					className={`rounded-3xl bg-white p-6 ${appearance === 'outlined' ? 'shadow-[0_0_16px_0_#F4F4F4]' : ''}`}
					key={index}
				>
					<p className="heading-secondary-title">{category}</p>
					<p className="body-default-bold mb-3">{title}</p>
					{typeof description === 'string' ? (
						<p className="body-small-regular">{description}</p>
					) : Array.isArray(description) ? (
						description.map((text, i) => (
							<p key={`infobox-text-${i}`} className="body-small-regular">
								{text}
							</p>
						))
					) : isReactElement(description) ? (
						description
					) : (
						<RichTextLexical content={description} />
					)}
				</div>
			))}
		</section>
	);
};
